import styled from 'styled-components'
import { LinkViewUnstyled } from './unstyled'

export const LinkView = styled(LinkViewUnstyled)`
  fill: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fontSizes.city.card.link};
  color: ${props => props.theme.colors.regentGray};
  display: inline-block;
  line-height: 16px;

  &:hover {
    text-decoration: none;
  }

  svg {
    height: 15px;
    width: 18px;
    margin-right: 7px;
    vertical-align: middle;
  }
`
